import React from 'react';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  type ChartOptions,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Card, Grid, useMantineTheme } from '@mantine/core';
import { HelpDialog } from './HelpDialog';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

function StatsVerticalBarChart(props: {
  data: {
    labels: string[];
    datasets: { label: string; data: number[]; backgroundColor: string }[];
  };
  title: string;
  stacked: boolean;
  description: string;
  editingDescription: string;
}) {
  const theme = useMantineTheme();
  const options: ChartOptions<'bar'> = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        display: false,
      },
      title: {
        display: true,
        text: props.title,
        font: {
          family: `Greycliff CF, ${theme.fontFamily}`,
          size: theme.fontSizes.md,
          weight: 'bold',
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        stacked: props.stacked,
      },
      y: {
        grid: {
          display: false,
        },
        stacked: props.stacked,
      },
    },
  };
  const ref = React.useRef(null);
  ref.current?.update();
  return (
    <Card withBorder p="xl" radius="md" sx={{ height: '100%' }}>
      <Grid>
        <Grid.Col xs={12}>
          <Bar ref={ref} options={options} data={props.data} height={'auto'} />
        </Grid.Col>
        <Grid.Col xs={12}>
          <HelpDialog
            description={props.description}
            EditingDescription={props.editingDescription}
          />
        </Grid.Col>
      </Grid>
    </Card>
  );
}

export default StatsVerticalBarChart;
